import { useState } from 'react';

const useModal = () => {
  const [modal, setModal] = useState({
    isOpen: false,
    message: '',
  });

  function toggleModal(message = '') {
    setModal({ isOpen: !modal.isOpen, message });
  }

  return {
    modal,
    toggleModal,
  };
};

export default useModal;
